import { render, staticRenderFns } from "./DuplicateTemplateModal.vue?vue&type=template&id=e1f849ca&"
import script from "./DuplicateTemplateModal.vue?vue&type=script&lang=js&"
export * from "./DuplicateTemplateModal.vue?vue&type=script&lang=js&"
import style0 from "./DuplicateTemplateModal.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports